import bind from 'bind-decorator';
import { action, observable, makeObservable } from 'mobx';

import App from '../App';

import { SceneManager as Base } from '@egr/xbox/threeD/managers/SceneManager';
import { ShadowMapping } from '@egr/wcf/modules/core/rendering/ShadowMapping';
import { AppInitOptions } from '@egr/wcf/modules/core';

export class SceneManager extends Base<App> {
    public shadowMapping: ShadowMapping | undefined;
    public override get appInitOptions(): Partial<AppInitOptions> {
        return {
            ...super.appInitOptions,
            audioEngine: true,
        };
    }

    constructor(oapPlanningMode: boolean) {
        super(oapPlanningMode);
        this.onAnimationStarted = this.onAnimationStarted.bind(this);
        this.onAnimationPaused = this.onAnimationPaused.bind(this);
        this.onAnimationEnded = this.onAnimationEnded.bind(this);
        makeObservable(this);
    }

    @observable
    public cameraPathInfo: {
        available: boolean;
        playing: 'STARTED' | 'PAUSED' | 'ENDED';
    } = {
        available: false,
        playing: 'ENDED'
    };

    @bind
    public toggleCameraPath(): void {
        if (!this.app.roomManager.cameraPathExists()) {
            return;
        }

        switch (this.cameraPathInfo.playing) {
            case 'ENDED':
                this.app.musicManager.setMute(false);
                return this.app.roomManager.startPathAnimation();
            default:
                this.app.roomManager.pathAnimation_pause();
        }
    }

    @bind
    public initializeCameraPathInformation(): void {
        this.cameraPathInfo = {
            playing: 'ENDED',
            available: this.app.roomManager.cameraPathExists()
        };
    }

    @action
    public onAnimationStarted(): void {
        this.cameraPathInfo = {
            available: this.cameraPathInfo.available,
            playing: 'STARTED'
        };
    }

    @action
    public onAnimationPaused(): void {
        this.cameraPathInfo = {
            available: this.cameraPathInfo.available,
            playing: 'PAUSED'
        };
    }

    @action
    public onAnimationEnded(): void {
        this.cameraPathInfo = {
            available: this.cameraPathInfo.available,
            playing: 'ENDED'
        };
    }
}